import { useState } from 'react';
import { useDispatch,useSelector } from 'react-redux';
import { Link,useLocation  } from 'react-router-dom';

import { visualizerActions, uiActions } from '../../store';

import { ChamUploadButton } from '../ChamUpload/ChamUpload';
import PrintLink from '../PrintLink/PrintLink';
import { saveProject } from "../../Helpers/ProjectsHelper";

import styles from './TopMenu.module.css';

import logo from './assets/logo.png';
import closeIcon from './assets/close.svg';
import openIcon from './assets/open.svg';
import { useNavigate } from 'react-router-dom';

export default function TopMenu({ extended,page }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const compareData = useSelector(state => state.visualizer.compareData);
    const appliedProducts = useSelector(s => s.visualizer.appliedProducts);
    const activeFlooringSeriesIds = useSelector(s => s.visualizer.activeFlooringSeriesIds);
    const specifier = useSelector(s => s.visualizer.specifier);
    const location = useLocation();
    
 
    // Holds the mobile menu open/closed status
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleStartOver = () => {
        document.getElementById('chamVizSub').style.visibility = 'hidden';
        dispatch(visualizerActions.setCompareData({ key: 'active', value: false }));
        navigate('/');
    };

    // Update mobile menu status on the hamburger icon click
    const handleMenuTriggerClick = function () {
        setIsMobileMenuOpen(status => !status);
    }

    const handleShareModalButtonClick = function () {
        dispatch(uiActions.setShareModalActive(true));
    }
    const handleHelpModalButtonClick = function () {
        dispatch(uiActions.setHelpModalActive(true));
    }

    const handleFeedbackModalButtonClick = function () {
        dispatch(uiActions.setFeedbackModalActive(true));
    }


    const handleProjectSave = function () {

        const payload = saveProject({
            specifier,
            appliedProducts,
            locationSearch: location.search,
            appliedKey: 'chamViz',
            activeFlooringSeriesIds
            
      });
    }

    const handleProjectsOpen = function () {

        dispatch(uiActions.setProjectsModalActive(true));
    }


    return (
        // <section style={{ display: 'none' }} className={styles.topMenu}>
         <section className={styles.topMenu}>
            <nav aria-label="Main Navigation">
                <ul className={!isMobileMenuOpen ? styles.closed : ''}>
                    {/* <li className={styles.logo}>
                        <Link to="/" aria-label="Home">
                            <img src={logo} alt="Company Logo" />
                        </Link>
                    </li> */}

                    <li className={styles.menuTrigger}>
                        <button onClick={handleMenuTriggerClick} aria-expanded={isMobileMenuOpen} aria-controls="main-menu">
                            <span aria-hidden="true">
                                {!isMobileMenuOpen && <img src={openIcon} alt='open icon' />}
                                {isMobileMenuOpen && <img src={closeIcon} alt='close icon' />}
                            </span>
                        </button>
                    </li>

                    {page !== 'landing' && (
                        <>
                            {/* <li>
                                <button type="button" onClick={handleStartOver} className="link-style">
                                    Start Over
                                </button>
                            </li> */}
                            
                        {extended && (<li><Link to="/roomscenes" aria-label="New scene Button">New Scene</Link></li> )}
                            <li>
                                <ChamUploadButton title="Upload Photo" className="" aria-label="Upload Button" />
                            </li>

                                   
                        </>
                    )}

                        {1==1 && (
                            <>
                                <li>
                                    <PrintLink />
                                </li>

                                <li>
                                    <button type="button" onClick={handleShareModalButtonClick} aria-label="Share">
                                        <span>Share Link</span>
                                    </button>
                                </li>
                            </>
                        )}

                   
                    {extended && (
                        <li>
                            <button type="button" onClick={handleProjectSave} aria-label="Projects">
                                <span>Save Project</span>
                            </button>
                        </li>
                    )}
                    {/* <li>
                        <button type="button" onClick={handleProjectsOpen} aria-label="Projects">
                            <span>My Projects</span>
                        </button>
                    </li> */}
                    
                    {extended && (<>
                        

                        


                        <li>
                            <button type="button" onClick={handleFeedbackModalButtonClick} aria-label="Feedback">
                                <span>Feedback</span>
                            </button>
                        </li>

            

                        {page === 'landing' && (
                            <li>
                                <Link to="/roomscenes" aria-label="Get started button">Get Started</Link>
                            </li>
                        )}
                        {/* <li className={styles.quote}>
                            <button type="button" onClick={() => window.open('https://www.southernluxeflooring.com/start-your-project', '_blank')} aria-label="Request a Quote">
                                <span>Request a Quote</span>
                            </button>
                        </li> */}

<li>
                            <button type="button" onClick={handleHelpModalButtonClick} aria-label="Share">
                                <span>Help</span>
                            </button>
                        </li>

                    </>
                    

                    )}


                </ul>
            </nav>
        </section>
    );
}

